import { render, staticRenderFns } from "./SPIFProfitloss.vue?vue&type=template&id=70bb0957"
import script from "./SPIFProfitloss.vue?vue&type=script&lang=js"
export * from "./SPIFProfitloss.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfitloss.vue?vue&type=style&index=0&id=70bb0957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports